import { FormattedMessage } from 'react-intl';
import StepItem from '../stepItem/StepItem';
import { Button, Icon, Modal } from '@iwoca/orion';
import styles from './PennyTransferAction.module.css';
import messages from './PennyTransferAction.messages';
import { useState } from 'react';
import { PennyTransferModal } from './pennyTransferModal/PennyTransferModal';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';

export const PennyTransferAction = ({
    status,
    triggerRefetchFundingRequirements
}: {
    status: TFundingRequirementsSteps['0']['status'];
    triggerRefetchFundingRequirements: () => void;
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleModalClose = () => {
        setIsModalOpen(!isModalOpen);
        triggerRefetchFundingRequirements();
    };

    return (
        <>
            <StepItem
                title={<FormattedMessage {...messages.title} />}
                caption={<FormattedMessage {...messages.caption} />}
                action={
                    status === 'COMPLETED' ? (
                        <Icon
                            icon="checkCircleFilled"
                            height="24"
                            width="24"
                            fill="rgba(0, 77, 51, 1)"
                            className={styles.actionIcon}
                            xlinkTitle="checked"
                        />
                    ) : (
                        <Button
                            variant="primary"
                            onClick={() => setIsModalOpen(true)}
                        >
                            <FormattedMessage {...messages.action} />
                        </Button>
                    )
                }
            />

            <Modal isOpen={isModalOpen} onClose={handleModalClose} closeIcon>
                <PennyTransferModal />
            </Modal>
        </>
    );
};
